import InvitePolitely from "./component/invitePolitely";

const InvitePolitelyPage = () => {
  return <InvitePolitely />;
};

export default InvitePolitelyPage;
